import { get } from "lodash";
import { Check } from "lucide-react";
import { FC, useMemo } from "react";

import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { useGetSKUsForSKUSelectionQuery } from "@/data/queries";
import { cn } from "@/lib/utils";

interface Props {
  selectedSKUId?: string;
  onSelect: (skuId: string) => void;
}

export const SKUCommand: FC<Props> = ({ onSelect, selectedSKUId }) => {
  const query = useGetSKUsForSKUSelectionQuery();

  const templates = useMemo(() => get(query, "data.templates", []), [query]);

  return (
    <Command
      filter={(value, search) => {
        return value.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
      }}
    >
      <CommandInput placeholder="SKU ID" />
      <CommandList>
        <CommandEmpty>No results</CommandEmpty>
        {templates.map((sku) => (
          <CommandItem
            key={sku.id}
            value={sku.id}
            onSelect={() => onSelect(sku.id)}
          >
            {sku.id} - {sku.name}
            <Check
              className={cn(
                "ml-auto",
                selectedSKUId === String(sku.id) ? "opacity-100" : "opacity-0",
              )}
            />
          </CommandItem>
        ))}
      </CommandList>
    </Command>
  );
};
